import { render } from "./Tree.vue?vue&type=template&id=e2fcc3a0&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=e2fcc3a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2fcc3a0"

export default script